export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser?.permissions || [];
  const permissionSet = new Set(permissions.map((p) => p.permissionCode));

  return {
    canAdmin: !!(currentUser && currentUser.access === 'admin'),

    // QRCode
    canQrcodeList: permissionSet.has('qrcode:list'),
    canQrcodeView: permissionSet.has('qrcode:view'),
    canQrcodeCreate: permissionSet.has('qrcode:create'),
    canQrcodeEnable: permissionSet.has('qrcode:enable'),
    canQrcodeDisable: permissionSet.has('qrcode:disable'),
    canQrcodeEnableBatch: permissionSet.has('qrcode:enable:batch'),
    canQrcodeDisableBatch: permissionSet.has('qrcode:disable:batch'),

    // Order
    canOrderList: permissionSet.has('order:list'),
    canOrderView: permissionSet.has('order:view'),
    canOrderDelay: permissionSet.has('order:delay'),
    canOrderDeduct: permissionSet.has('order:deduct'),
    canOrderComplete: permissionSet.has('order:complete'),
    canOrderExport: permissionSet.has('order:export'),
    canOrderDelayBatch: permissionSet.has('order:delay:batch'),
    canOrderCompleteBatch: permissionSet.has('order:complete:batch'),

    // Product
    canProductList: permissionSet.has('product:list'),
    canProductCreate: permissionSet.has('product:create'),
    canProductEdit: permissionSet.has('product:edit'),
    canProductDelete: permissionSet.has('product:delete'),
    canProductEnable: permissionSet.has('product:enable'),
    canProductDisable: permissionSet.has('product:disable'),
    canProductEnableBatch: permissionSet.has('product:enable:batch'),
    canProductDisableBatch: permissionSet.has('product:disable:batch'),

    // Config
    canConfigAgreement: permissionSet.has('config:agreement'),
    canConfigMobile: permissionSet.has('config:mobile'),

    // System & Permission
    canLogList: permissionSet.has('log:list'),
    canUserList: permissionSet.has('user:list'),
    canRoleEdit: permissionSet.has('role:edit'),
    canPermissionEdit: permissionSet.has('permission:edit'),
  };
}
